import {useEffect} from 'react';
import {useNavigate} from 'react-router';

import Container from 'components/container/Container';
import Button from 'components/button/Button';

const Failed = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => navigate('/'), 5000);
  }, [navigate]);

  return (
    <Container>
      <div>Failed to subscribe. Please try again.</div>
      <div>
        <Button
          title="Go back"
          className="my-4"
          onClick={() => {
            navigate('/');
          }}
        />
      </div>
    </Container>
  );
};

export default Failed;
